export const KPI_TYPES = {
    TOTAL_READINGS: 'totalReadings',
    AVG_READINGS: 'avgReadings',
    DAYS_WITHOUT_READING: 'daysWithoutReading',
    GMI: 'GMI',
    VERY_HIGH: 'veryHigh',
    VERY_LOW: 'veryLow',
    STANDARD_DEVIATION: 'standardDeviation',
    AVERAGE: 'average',
    AVERAGE_PRE_MEAL: 'averagePreMeal',
    AVERAGE_POST_MEAL: 'averagePostMeal',
    CV: 'CV'
};
export const KPI_LEVELS = {
    HIGH: 'high',
    TARGET: 'target',
    LOW: 'low',
    NEUTRAL: 'neutral'
};
export const GMI_THRESHOLDS = {
    LOW: 5,
    HIGH: 7
};
export const CV_THRESHOLDS = {
    NEUTRAL: 33
};
